// removed by extract-text-webpack-plugin
module.exports = {"checkbox":"_2NEsugv3GylQmyxFGN5ghe"};


//////////////////
// WEBPACK FOOTER
// ./src/components/OMComponents/OMMultiCheckbox/OMMultiCheckbox.scss
// module id = 1662
// module chunks = 0